document.addEventListener('DOMContentLoaded', function () {
  if (!window.matchMedia('(max-width: 600px)').matches) return;

  const header = document.querySelector('#header-toolbar');
  if (!header) return;

  const announcements = document.querySelectorAll(
    '[data-section-type="header_announcement"]'
  );

  let lastScrollY = window.scrollY;
  let ticking = false;
  let thresholdY = 0;

  // HARDYPAW PERFORMANCE OPTIMIZATION - 2026-09-02
  // Cache the scroll threshold to avoid repeated layout measurements on scroll.
  function calculateThreshold() {
    if (announcements.length === 0) {
      thresholdY = header.offsetTop + header.offsetHeight;
    } else {
      const bottomAnnouncement = announcements[announcements.length - 1];

      thresholdY =
        bottomAnnouncement.getBoundingClientRect().top + window.scrollY;
    }
  }

  calculateThreshold();

  function updateHeader() {
    ticking = false;

    const currentScrollY = window.scrollY;

    if (currentScrollY < thresholdY || currentScrollY < lastScrollY) {
      header.classList.remove('header--hidden');
    } else if (currentScrollY > lastScrollY) {
      header.classList.add('header--hidden');
    }

    lastScrollY = currentScrollY;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (ticking) return;

      ticking = true;
      window.requestAnimationFrame(updateHeader);
    },
    { passive: true }
  );

  // Recalculate only when viewport dimensions actually change.
  window.addEventListener(
    'resize',
    function () {
      calculateThreshold();
    },
    { passive: true }
  );
});